/**
 * @license Copyright © HatioLab Inc. All rights reserved.
 */

import '@material/web/icon/icon.js'
import './selector/ox-board-selector.js'

import { css, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { i18next } from '@operato/i18n'
import { openPopup } from '@operato/layout'

@customElement('ox-editor-board-selector')
export class BoardSelector extends LitElement {
  static get styles() {
    return [
      css`
        :host {
          position: relative;
          display: inline-block;
        }

        input[type='text'] {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(0, 0, 0, 0.2);
        }

        md-icon {
          position: absolute;
          top: 0;
          right: 0;
        }
      `
    ]
  }

  @property({ type: String }) value?: string
  @property({ type: Object }) properties?: any

  private popup: any

  render() {
    return html`
      <input id="text" type="text" .value=${this.value || ''} @change=${(e: Event) => this._onInputChanged(e)} />

      <md-icon @click=${(e: MouseEvent) => this.openSelector()}>dashboard</md-icon>
    `
  }

  _onInputChanged(e: Event) {
    this.value = (e.target as any)?.value
    this.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true }))
  }

  openSelector() {
    if (this.popup) {
      delete this.popup
    }

    /*
     * 기존 설정된 보드가 선택된 상태가 되게 하기 위해서는 selector에 value를 전달해줄 필요가 있음.
     * 주의. value는 object일 수도 있고, string일 수도 있다.
     * string인 경우에는 해당 보드의 id로 해석한다.
     */
    var value = this.value || {}

    var template = html`
      <ox-board-selector
        .creatable=${true}
        .value=${value}
        @board-selected=${async (e: CustomEvent) => {
          var board = e.detail.board
          this.value = board.id

          this.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true }))

          this.popup && this.popup.close()
        }}
      ></ox-board-selector>
    `

    this.popup = openPopup(template, {
      backdrop: true,
      size: 'large',
      title: i18next.t('title.select board')
    })
  }
}
